var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Diamond = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 945 874.06", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M933.05 218.51L805.68 40.2A96.19 96.19 0 0 0 727.57 0H217.44a96.19 96.19 0 0 0-78.12 40.2L12 218.51a63.84 63.84 0 0 0 .55 75.16L421 848a64 64 0 0 0 103 0l408.49-554.33a63.84 63.84 0 0 0 .56-75.16zM288.07 288l117.86 431.7L87.83 288zm66.34 0h236.18L472.5 720.55zm302.53 0h200.23l-318.1 431.7zM191.4 77.4a32 32 0 0 1 26-13.4h510.17a32 32 0 0 1 26 13.4L858.32 224H86.68z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Diamond;
//# sourceMappingURL=Diamond.js.map